import PercentageTypes from './percentage.types';

const initialState = {
  totalPercentage: {
      ios: 50,
      android: 50,
  }
};

const percentageReducer = (state = initialState, action) => {
  switch (action.type) {
    case PercentageTypes.SET_CALL_PERCENTAGE:
      return { ...state, totalPercentage: action.payload };
    default:
      return state;
  }
};

export default percentageReducer;
